import { useFormErrorsStore } from "@/stores/formErrors";

export default {
    beforeMount: (el, binding) => {
        let fieldName = binding.value;
        let invalidClass = "invalid";
        const formErrorsStore = useFormErrorsStore();
        if (typeof fieldName === "object") {
            fieldName = binding.value.name;
            invalidClass = binding.value.class;
        }
        if (binding.modifiers.input) {
            el.addEventListener("change", () => {
                if (
                    Object.prototype.hasOwnProperty.call(
                        formErrorsStore.errors,
                        fieldName
                    )
                ) {
                    formErrorsStore.removeErrors(fieldName);
                }
            });
            return;
        }

        el.formErrorUnsub = formErrorsStore.$onAction(
            ({name, args}) => {
                if(name === 'removeErrors' && args[0] === fieldName) {
                    el.classList.remove(invalidClass);
                    if (binding.modifiers.messages) {
                        el.innerHTML = "";
                    }
                    if (binding.modifiers.input) {
                        el.setCustomValidity("");
                        el.classList.remove("invalid");
                    }
                    return;
                }
                if(name === 'clearErrors') {
                    el.classList.remove(invalidClass);
                    if (binding.modifiers.messages) {
                        el.innerHTML = "";
                    }
                    if (binding.modifiers.input) {
                        el.setCustomValidity("");
                        el.classList.remove("invalid");
                    }
                    return;
                }

                const errors = args[0];
                for (const [key, value] of Object.entries(errors)) {
                    if (key === fieldName) {
                        el.classList.add(invalidClass);
                        if (binding.modifiers.messages) {
                            el.innerHTML = value;
                        }
                        if (binding.modifiers.input) {
                            el.setCustomValidity(value);
                            el.classList.add("invalid");
                        }
                    }
                }
            }
        );
    },
    beforeUnmount: el => {
        if (el.formErrorUnsub) {
            el.formErrorUnsub();
        }
    }
};
